import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { UserType } from '@features/admin/@shared/enums/user-type.enum';
import { UserRole } from '@services/auth/role.enum';
import { AuthService } from '@services/core/auth.service';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { SidenavService } from './side-nav.service';

@Component({
  selector: 'side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit, AfterViewInit {
  UserRole = UserRole;
  @ViewChild('rightSidenav')
  rightSidenav: MatSidenav;
  isLoggedIn$: Observable<boolean>;
  userUniqueId: string;
  UserType = UserType;
  constructor(public sidenavService: SidenavService, private authService: AuthService, public router: Router) {
    this.isLoggedIn$ = this.authService.isLoggedIn$;
  }

  async ngOnInit(): Promise<void> {
    this.userUniqueId = await this.authService.activeUserId$.pipe(take(1)).toPromise();
  }
  ngAfterViewInit() {
    this.sidenavService.setSidenav(this.rightSidenav);
  }
}
